module.exports = __webpack_public_path__ + "static/media/refunded.53c73c22.svg";